import { AccordionFilter, IAccordionFilterProps } from 'core-components/library/filter'
import { IProperties } from 'core-components/sitebuilder/propertygenerator'

import { EventBusController } from '../EventBusController'

import { accordionFilterEvents, AccordionFilterEvents } from './accordionFilter/eventBusData'

interface IAccordionFilterEditor {
  props: IAccordionFilterProps
  eventBusData?: IProperties
}

export const AccordionFilterEditor = ({ props, eventBusData }: IAccordionFilterEditor) => {
  return (
    <AccordionFilter
      {...props}
      onChange={(filter) => {
        if (eventBusData?.value) {
          const eventBus = EventBusController.getEventBus(
            `${eventBusData.value}`,
            accordionFilterEvents
          )
          eventBus.notify(AccordionFilterEvents.filterChanged, filter)
        }
      }}
    />
  )
}
